import React from 'react';

interface AreaGradientProps {
    className?: string;
    identifier: string;
    startOffset: string;
    stopOffset: string;
}

export default function AreaGradient(props: AreaGradientProps) {
    const { className, identifier, startOffset, stopOffset } = props;

    return (
        <svg className="AreaGradient">
            <defs>
                <linearGradient
                    id={identifier}
                    className={className}
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%"
                >
                    <stop offset={startOffset} />
                    <stop offset={stopOffset} />
                </linearGradient>
            </defs>
        </svg>
    );
}
